<!--<div [formGroup]="form">
  <label for="check_1" class="checkbox-inline">
    <input type="radio" name="doccat" formControlName="doccat" value="conveyances" id="check_1" />
    conveyances
  </label>
  <label for="check_2" class="checkbox-inline">
    <input type="radio" name="doccat" formControlName="doccat" value="mortgages" id="check_2" />
    mortgages
  </label>

</div>-->

  <div [formGroup]="form">
    <div class="form-check-inline">
      <input type="radio" class="form-check-input" name="doccat" formControlName="doccat" value="conveyances" id="check_1" />
      <label for="check_1" class="form-check-label"> conveyances </label>
    </div>
    <div class="form-check-inline">
      <input type="radio" class="form-check-input" name="doccat" formControlName="doccat" value="mortgages" id="check_2" />
      <label for="check_2" class="form-check-label">mortgages </label>
    </div>
  </div>
